import React from 'react'

// import General from '../tabs/settings/components/general/General/General'
// import Hours from '../tabs/settings/components/hours/Hours'
// import NewPersistentMenu from '../tabs/settings/components/persistentMenu/PersistentMenu'
import Integrations from '../tabs/settings/components/integrations/NewIntegrations'
import Users from '../tabs/settings/components/users/Users'
// import Languages from '../tabs/settings/components/languages/Languages'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { RouteConfiguration } from 'routes/nlpRoutes'
import { ExternalLinkIcon } from 'uiKit/icons/ExternalLinkIcon'

export const settingsRoutes: RouteConfiguration[] = [
  // {
  //   path: 'general',
  //   name: 'General',
  //   component: General,
  // },
  // {
  //   path: 'languages',
  //   name: 'Languages',
  //   component: Languages,
  // },
  // {
  //   path: 'hours',
  //   name: 'Team Hours',
  //   component: Hours,
  // },
  {
    path: 'users',
    name: 'Users',
    component: Users,
    icon: () => <ManageAccountsIcon />,
  },
  {
    path: 'integrations',
    name: 'Integrations',
    component: Integrations,
    icon: () => <ExternalLinkIcon />,
  },
  // {
  //   path: 'persistent',
  //   name: 'Main Menu',
  //   component: NewPersistentMenu,
  // }
]
